import CustomState from '@rio-cloud/rio-uikit/CustomState';
import { FormattedMessage } from 'react-intl';

export type ConnectionErrorStateProps = {
    reloadTriggerFunction?: () => void;
};

const ConnectionErrorState = ({ reloadTriggerFunction }: ConnectionErrorStateProps) => {
    return (
        <CustomState
            headline={<FormattedMessage id="intl-msg:common.error.emptyState.headline" />}
            message={<FormattedMessage id="intl-msg:batteryService.error.connectionIssue" />}
            icons={[
                {
                    name: 'rioglyph rioglyph-pylon',
                },
            ]}
            buttons={[
                {
                    text: <FormattedMessage id="intl-msg:common.error.emptyState.button" />,
                    onClick: reloadTriggerFunction,
                },
            ]}
        />
    );
};

export default ConnectionErrorState;
